<script setup lang="ts">
import { WEB_APP_URL } from '~/constants/website'

definePageMeta({
  custom_meta_data: {
    topic: 'integrasi',
    message: 'Saya tertarik dengan plugin WooCommerce KiriminAja'
  }
})

useDefaultMeta({
  title: 'Plugin WooCommerce Ongkir & Cek Resi Otomatis | KiriminAja',
  description:
    'Kelola ongkir & cek resi otomatis dari berbagai ekspedisi di WooCommerce. Plugin gratis KiriminAja bikin pengiriman makin cepat & efisien!',
  robots: 'index, follow',
  schema: {
    type: ['SoftwareApplication', 'WebApplication'],
    title: 'Plugin WooCommerce'
  }
})

const faqs = [
  {
    question:
      'Bagaimana cara menampilkan ongkos kirim otomatis di WooCommerce?',
    answer:
      'Install plugin, hubungkan akun KiriminAja, atur kurir/layanan—tarif muncul otomatis di Cart & Checkout.'
  },
  {
    question: 'Apakah plugin ini gratis?',
    answer:
      'Ya. Tidak ada biaya bulanan. Anda hanya membayar ongkos kirim dari ekspedisi yang digunakan.'
  },
  {
    question: 'Apakah pelanggan bisa cek resi langsung di website toko?',
    answer:
      'Bisa. Fitur cek resi real-time tersedia dan bisa dikustomisasi sesuai brand Anda.'
  },
  {
    question: 'Apakah plugin ini hanya untuk satu kurir?',
    answer:
      'Tidak. Plugin mendukung multi-ekspedisi melalui KiriminAja— JNE, J&T Express, SiCepat, AnterAja, POS, Paxel, Borzo, dan lainnya.'
  },
  {
    question: 'Apakah plugin ini kompatibel dengan versi terbaru WooCommerce?',
    answer:
      'Ya, plugin selalu diperbarui agar sesuai dengan versi terbaru WooCommerce dan WordPress.'
  }
]

const schema = {
  '@context': 'https://schema.org',
  '@type': 'WebApplication',
  name: 'KiriminAja WordPress Plugin',
  operatingSystem: 'WordPress',
  applicationCategory: 'BusinessApplication',
  aggregateRating: {
    '@type': 'AggregateRating',
    ratingValue: 5,
    ratingCount: 100
  },
  offers: {
    '@type': 'Offer',
    price: 0
  }
}

useHead({
  script: [
    {
      key: 'ld-software-application-shopify',
      type: 'application/ld+json',
      innerHTML: JSON.stringify(schema)
    }
  ]
})
</script>

<template>
  <HeroBase
    title="Semua Ekspedisi, Satu Plugin Ongkos Kirim & Cek Resi Otomatis"
    sub-title="Plugin WooCommerce KiriminAja"
    description="Tingkatkan penjualan dan efisiensi dengan Plugin WooCommerce KiriminAja. Tampilkan ongkir & cek resi otomatis di checkout, integrasi cepat tanpa coding, dukungan multi-ekspedisi, dan fitur COD tanpa pending."
    hero-image="/images/plugin/woocommerce/hero.webp"
  >
    <template #action>
      <div class="flex items-center gap-2 lg:gap-4 py-2">
        <UiButton
          :to="
            $utm.utmUrl(
              WEB_APP_URL +
                '/register?redirectTo=/settings/api-request?plugin=woocommerce'
            )
          "
          label="Install Plugin"
          icon="material-symbols:download"
        />
        <UiButton
          :to="$utm.utmUrlWithCustomMetaData('/kontak-kami')"
          label="Hubungi Kami"
          variant="primaryOutline"
          icon="material-symbols:call-outline"
        />
      </div>
    </template>
  </HeroBase>

  <SolusiPluginWoocommerceFiturDashboard />
  <SolusiPluginWoocommerceKeuntungan />
  <SolusiPluginWoocommerceCaraInstall />
  <PresetClients
    title="Dipercaya oleh 370.000+ Seller & Brand Owner di Seluruh Indonesia"
  />
  <SolusiPluginWoocommerceMiniCta />
  <PresetCourier
    title="Semua Ekspedisi Favoritmu, Siap di WooCommerce – KiriminAja"
    path="/solusi/plugin-woocommerce"
  />
  <FaqBase
    title="Pertanyaan Umum Seputar Plugin WooCommerce KiriminAja"
    :faqs="faqs"
  />
  <SolusiPluginWoocommerceCta />
</template>
